import React from "react";
import Layout from "../../../shared/Layout/Layout";
import NewsHeader from "../../../shared/Components/NewsHeader";
import NationalImpactInvestDetails from "./component/NationalImpactInvestDetails";

export default function NationalImpactInvest() {
  return (
    <Layout>
      <NewsHeader>National Impact Investment Day 10th November</NewsHeader>
      <NationalImpactInvestDetails />
    </Layout>
  );
}
